import { dateToApiFormat } from '@/helpers/dateHelper';
import { SeverityType } from '@/services/warnings/warningDefinitions';
import { WorkingShift } from '@/types/daily.types';
import { RosterWarningModel, WarningsProps } from '../../../pages/roster/warnings/warnings.types';

export const getLeftCompanyWarnings = (shift: WorkingShift, props: WarningsProps): RosterWarningModel[] => {
  const { strings, allEmployees, workingRoster } = props;
  const allocatedEmployee = allEmployees.find(e => e.identityId === shift.assignedEmployeeId);

  const leaveDate = allocatedEmployee?.leaveDate;
  const rosterDate = workingRoster.date;

  const warnings: RosterWarningModel[] = [];

  if (leaveDate && leaveDate < dateToApiFormat(rosterDate)) {
    warnings.push({
      name: strings.leftCompany(leaveDate),
      severity: SeverityType.CRITICAL,
      shiftId: shift.id
    });
  }

  return warnings;
};
